import { useRef, type RefObject } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import type { OrbitControls as OrbitControlsImpl } from "three-stdlib";
import type { CompassHandle } from "../Compass";

/** 카메라 azimuth를 매 프레임 Compass에 imperatively 전달 (React 리렌더 없음). */
export function AzimuthTracker({ compassRef }: { compassRef: RefObject<CompassHandle | null> }) {
  const { camera, controls } = useThree() as unknown as {
    camera: { position: { x: number; z: number } };
    controls: OrbitControlsImpl | null;
  };
  const lastDeg = useRef<number>(NaN);

  useFrame(() => {
    let azimuth: number;
    if (controls && typeof controls.getAzimuthalAngle === "function") {
      azimuth = controls.getAzimuthalAngle();
    } else {
      azimuth = Math.atan2(camera.position.x, camera.position.z);
    }
    const deg = (azimuth * 180) / Math.PI;
    if (!Number.isNaN(lastDeg.current) && Math.abs(deg - lastDeg.current) < 0.5) return;
    lastDeg.current = deg;
    compassRef.current?.setAzimuth(azimuth);
  });

  return null;
}
